<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <fieldset class="users-to-be-notified-section">
    <h2>Select who should be notified by email:</h2>
    <ng-select
      data-cy="users-to-notify"
      class="list-dropdown"
      [items]="users"
      [clearable]="false"
      formControlName="userIds"
      [multiple]="true"
      (open)="onOpen()"
      i18n-placeholder="Select..."
      placeholder="Select..."
      bindLabel="fullName"
      bindValue="id"
    >
    </ng-select>
  </fieldset>
  <fieldset>
    <h2>Set when to send notifications:</h2>
    <ol formGroupName="expiryTimes">
      <li
        class="sm-flex sm-gap-2 sm-items-center"
        *ngFor="
          let periodDefinition of form.controls['expiryTimes'].value | keyvalue: keepDefaultOrder;
          let index = index
        "
      >
        <input
          type="checkbox"
          [formControlName]="periodDefinition.key"
          [value]="true"
          [id]="uniqueIdentifier + periodDefinition.key"
          data-test="period-checkbox"
        />
        <label class="sm-cursor-pointer" [for]="uniqueIdentifier + periodDefinition.key">
          {{ notificationDescriptions[periodDefinition.key] }}
        </label>
      </li>
    </ol>
  </fieldset>
  <fieldset class="expiry-update-controls-container">
    <button class="expiry-update-control save" type="submit" [disabled]="!form.dirty">Save</button>
    <button class="expiry-update-control reset" type="button" (click)="resetForm()">Reset</button>
  </fieldset>
</form>
